import React from 'react';
import {
 IconCircleDashed,
 IconUsers,
 IconRocket,
 IconCurrencyDollar,
 IconCheck
} from '@tabler/icons-react';
import { cn } from '../../../../lib/utils';

const STAGE_CONFIG = {
 waiting_to_start: { title: 'Waiting', icon: IconCircleDashed, stageKey: 'waiting' },
 recruitment: { title: 'Recruitment', icon: IconUsers, stageKey: 'recruitment' },
 live: { title: 'Live', icon: IconRocket, stageKey: 'live' },
 payment_report: { title: 'Payments', icon: IconCurrencyDollar, stageKey: 'payment' },
 finished: { title: 'Finished', icon: IconCheck, stageKey: 'finished' },
};

const STAGE_STYLES = {
 waiting: { icon: 'text-text-tertiary', badge: 'bg-surface-3 text-text-tertiary' },
 recruitment: { icon: 'text-accent', badge: 'bg-accent-muted text-accent' },
 live: { icon: 'text-live', badge: 'bg-live-muted text-live' },
 payment: { icon: 'text-warning', badge: 'bg-warning-muted text-warning' },
 finished: { icon: 'text-text-tertiary', badge: 'bg-surface-3 text-text-tertiary' },
};

const MobileStageNavigation = ({ activeStage, onStageChange, counts }) => {
 const stageOrder = ['waiting_to_start', 'recruitment', 'live', 'payment_report', 'finished'];

 return (
 <div className="w-full border-b border-glass-border bg-surface-1/80">
 <div role="group" aria-label="Campaign stages" className="flex flex-wrap min-h-[44px]">
 {stageOrder.map((stage) => {
 const config = STAGE_CONFIG[stage];
 const styles = STAGE_STYLES[config.stageKey];
 const count = counts[stage] || 0;
 const IconComponent = config.icon;
 const isActive = activeStage === stage;

 return (
 <button
 key={stage}
 type="button"
 aria-pressed={isActive}
 onClick={() => onStageChange(stage)}
 className={cn(
 'relative flex items-center gap-1 flex-shrink-0 min-h-[44px] min-w-[68px] px-1.5',
 'border-b-[3px]',
 isActive ? 'border-accent' : 'border-transparent',
 )}
 >
 <IconComponent
 size={18}
 strokeWidth={2}
 className={isActive ? styles.icon : 'text-text-tertiary'}
 />
 <span className={cn(
 'text-sm whitespace-nowrap -tracking-tight',
 isActive ? 'font-semibold text-text-primary' : 'font-medium text-text-secondary',
 )}>
 {config.title}
 </span>
 <span className={cn(
 'inline-flex items-center justify-center font-semibold tabular-nums text-[10px] h-4 min-w-[16px] px-1',
 isActive ? styles.badge : 'bg-surface-2 text-text-tertiary',
 )}>
 {count}
 </span>
 </button>
 );
 })}
 </div>
 </div>
 );
};

export default MobileStageNavigation;
